import React, {useEffect, useState} from 'react';
import {Form, Input, Select, Switch, Button, Card, Row, Col, Typography, Modal, message, Space, Upload} from 'antd';
import {UserOutlined, PhoneOutlined, LockOutlined} from '@ant-design/icons';
import './Common.module.css';
import styles from './Common.module.css';
import {addSchoolAdminRequest, addUserRequest, getAliOssTokenRequest, getRegionListRequest} from "../api";
import OSS from "ali-oss";
import {ALI_OSS_PATH} from "../../../../util/constants";
import {getSixMathRandom} from "../../../../util/handMath";
import uploadImg from "./upload_picture.svg"
import uploadVideo from "./upload_video.svg"
import { clearAllCookies } from '../../../../util/handleObject';
let client;
let clientExpTime;
const {Title} = Typography;
const {Option} = Select;

const { TextArea } = Input;
const AddAccountForm = (props) => {
    const [provinceList, setProvinceList] = useState([]);
    const [municipalityList, setMunicipalityList] = useState([]);
    const [countyList, setCountyList] = useState([]);
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();

    const [fileList2, setFileList2] = useState([])
    const [previewImage, setPreviewImage] = useState("");
    const [previewVisible, setPreviewVisible] = useState(false);

    useEffect(() => {
        getRegionList("1","")
        getAliOssToken()
    }, []); // 空数组意味着这个 effect 只会在组件挂载时执行一次

    function getRegionList(regionCode, parentCode) {
        getRegionListRequest(regionCode, parentCode, (data) => {
            var newRegionList = [{
                quyu_name: "未选择",
                quyu_code: ""
            }];
            if (data.ret == 1) {
                data.data.forEach(element => {
                    newRegionList.push(element)
                });
            } else if (data.ret == 99) {
                messageApi.open({
                    type: 'warning',
                    content: data.msg
                });
                setTimeout((e) => {
                    sessionStorage.clear()
                    clearAllCookies()
                    window.location.reload()
                }, 1000)
            }
            if (regionCode == 1) {
                setProvinceList(newRegionList)
            } else if (regionCode == 2) {
                setMunicipalityList(newRegionList)
            } else if (regionCode == 3) {
                console.log("newRegionList=============+++++++++++++++++++++++==")
                console.log(newRegionList)
                setCountyList(newRegionList)
            }

        })
    }

    const onFinish = (values) => {
        var provinceName = provinceList.find(item => item.quyu_code == values.province).quyu_name;
        var dishiName =  municipalityList.find(item => item.quyu_code == values.dishi).quyu_name;
        var countyName = countyList.find(item => item.quyu_code == values.quxian).quyu_name;

        // 这里可以添加API调用或其他提交逻辑
        addSchoolAdminRequest(
            values.schoolName,
            values.schoolAddress,
            provinceName,
            values.province,
            dishiName,
            values.dishi,
            countyName,
            values.quxian,
            values.userName,
            values.login,
            values.pwd,
            values.chushijifen,
            values.schoolAccountNumber,
            values.accountStatus?1:3,
            values.beizhu?values.beizhu:"",
            (data)=>{
                console.log("ffffffffffffffffffff")
                console.log(data)
                if(data.ret == 1) {
                    props.refreshList();
                    closeCommon()
                }
                else {
                    message.warning(data.msg);
                }
            }

        )
    };


    const closeCommon = () => {
        setMunicipalityList([{
            quyu_name: "未选择",
            quyu_code: ""
        }])
        setCountyList([{
            quyu_name: "未选择",
            quyu_code: ""
        }])
        form.resetFields();
        setTimeout((e)=>{
            props.closeCommonModal()
        },100)
        props.closeCommonModal()
    };


    function isImage(filename) {
        const pattern = /\.(jpg|jpeg|png|gif|svg|bmp)$/i;
        return pattern.test(filename);
    }

    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    async function handlePreview(file) {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        if (isImage(file.url)) {
            setPreviewImage(file.url || file.preview)
            setPreviewVisible(true);
        } else {
            if (!file.url) {
                message.open({
                    type: "warning",
                    content: "链接无效"
                })
            }
            window.location.href = file.url
        }
    }

    function handleCancel() {
        setPreviewVisible(false);
    }
    function getAliOssToken() {
        let nowDate = new Date().getTime()
        if (!client || nowDate - clientExpTime > 1200000) {
            clientExpTime = new Date().getTime();
            getAliOssTokenRequest((data) => {
                if ("Credentials" in data) {
                    client = new OSS({
                        // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
                        region: 'oss-cn-qingdao',
                        // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
                        accessKeyId: data.Credentials.AccessKeyId,
                        accessKeySecret: data.Credentials.AccessKeySecret,
                        // 从STS服务获取的安全令牌（SecurityToken）。
                        stsToken: data.Credentials.SecurityToken,
                        refreshSTSToken: async () => {
                            // 向您搭建的STS服务获取临时访问凭证。
                            getAliOssTokenRequest((data) => {
                                return {
                                    accessKeyId: data.Credentials.AccessKeyId,
                                    accessKeySecret: data.Credentials.AccessKeySecret,
                                    stsToken: data.Credentials.SecurityToken,
                                }
                            })

                        },
                        // 刷新临时访问凭证的时间间隔，单位为毫秒。
                        refreshSTSTokenInterval: 3000000,
                        // 填写Bucket名称。
                        bucket: 'tgnp'
                    })
                }
            })
        }
    }
    function handleChange2(info) {
        getAliOssToken()
        let tempList = info.fileList.map((item, index) => {
            let tempDic = {
                "url": item.url,
                "uid": item.uid,
                "status": item.status,
                "name": item.name
            }
            return tempDic
        })
        setFileList2(tempList);
        if (info.file.status !== 'uploading') {
            console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {
            message.success(`${info.file.name} file uploaded successfully`);
        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
        }
    }
    const customRequest = async options => {
        const {onSuccess, onError, file} = options;

        try {
            // 使用阿里云OSS SDK上传文件
            let timestamp = new Date().getTime()
            let random = getSixMathRandom()
            const result = await client.put(ALI_OSS_PATH + "famousTeacher/" + timestamp + random + file.name, file);
            console.log(result)
            file.url = result.url.replace("http:","https:");
            onSuccess(file);
        } catch (e) {
            onError(e);
        }
    };

    return (
        <Modal
            maskClosable={false}
            // visible={true}
            open={props.openStatus}
            onCancel={closeCommon}
            footer={null} // 设置 footer 为 null 移除默认按钮
            width={800}
            // className="add-account-container"
        >
            {contextHolder}
            <Card className={styles["form-card"]} span={20}>
                <div className={styles["form-title"]}>添加名师信息</div>
                <Form
                    form={form}
                    layout="horizontal"
                    onFinish={onFinish}
                    className="account-form"
                >
                    <Form.Item
                        label="教师姓名"
                        name="teacherName"
                        rules={[{required: true, message: '请输入教师姓名'}]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <Input
                            placeholder="请输入教师姓名"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="教学资质"
                        name="jiaoxuezi"
                        rules={[{required: true, message: '请输入教学资质'}]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <TextArea
                            placeholder="请输入教学资质"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="个人简介"
                        name="gerenjianjie"
                        rules={[{required: true, message: '请输入个人简介'}]}
                        labelAlign="right"
                        labelCol={{span: 5}}
                    >
                        <TextArea
                            placeholder="请输入个人简介"
                            size="large"
                        />
                    </Form.Item>

                    <Form.Item
                        label="个人形象照"
                    >
                        <div className={styles.uploadWidth}>
                            <Upload
                                listType="picture-card"
                                fileList={fileList2}
                                onPreview={handlePreview}
                                onChange={handleChange2}
                                customRequest={customRequest}
                                accept=".pdf,.doc,.docx,.ppt,.pptx,.jpg,.png,.jpeg,.svg,.gif,.xls,.xlsx"
                                // disabled={true}
                                className={styles.mineUpload}
                            >
                                {fileList2.length >= 1 ? null : <div className={styles.uploadButton}>
                                    <img className={styles.uploadImgIcon} src={uploadImg}/>点击上传图片
                                </div>}
                            </Upload>
                            <Modal open={previewVisible} footer={null}
                                   onCancel={handleCancel}
                                   width={1200}
                            >
                                <img alt="example" style={{width: '100%'}} src={previewImage}/>
                            </Modal>
                        </div>
                    </Form.Item>
                    <Form.Item
                        label="教学视频"
                    >
                        <div className={styles.uploadWidth}>
                            <Upload
                                listType="picture-card"
                                fileList={fileList2}
                                onPreview={handlePreview}
                                onChange={handleChange2}
                                customRequest={customRequest}
                                accept=".pdf,.doc,.docx,.ppt,.pptx,.jpg,.png,.jpeg,.svg,.gif,.xls,.xlsx"
                                // disabled={true}
                                className={styles.mineUpload}
                            >
                                {fileList2.length >= 100 ? null : <div className={styles.uploadButton}>
                                    <img className={styles.uploadImgIcon} src={uploadVideo}/>点击上传视频
                                </div>}
                            </Upload>
                            <Modal open={previewVisible} footer={null}
                                   onCancel={handleCancel}
                                   width={1200}
                            >
                                <img alt="example" style={{width: '100%'}} src={previewImage}/>
                            </Modal>
                        </div>
                    </Form.Item>
                    <Form.Item
                        label="精选课件"
                    >
                        <div className={styles.uploadWidth}>
                            <Upload
                                listType="picture-card"
                                fileList={fileList2}
                                onPreview={handlePreview}
                                onChange={handleChange2}
                                customRequest={customRequest}
                                accept=".pdf,.doc,.docx,.ppt,.pptx,.jpg,.png,.jpeg,.svg,.gif,.xls,.xlsx"
                                // disabled={true}
                                className={styles.mineUpload}
                            >
                                {fileList2.length >= 100 ? null : <div className={styles.uploadButton}>
                                    <img className={styles.uploadImgIcon} src={uploadVideo}/>点击上传课件
                                </div>}
                            </Upload>
                            <Modal open={previewVisible} footer={null}
                                   onCancel={handleCancel}
                                   width={1200}
                            >
                                <img alt="example" style={{width: '100%'}} src={previewImage}/>
                            </Modal>
                        </div>
                    </Form.Item>
                    <Form.Item className={styles["form-actions"]}>

                        <Button

                            size="large"
                            // onClick={() => form.resetFields()}
                            onClick={(e)=>{
                                // props.cancel()
                                form.resetFields()
                                closeCommon()
                            }}
                        >
                            取消
                        </Button>

                        <Button
                            type="primary"
                            htmlType="submit"
                            size="large"
                            style={{marginLeft: 16}}
                        >
                            确认
                        </Button>

                    </Form.Item>
                </Form>
            </Card>
        </Modal>
    );
};

export default AddAccountForm;
